import { useEffect, useState } from 'react';

/**
 * SSR-safe md-breakpoint check (false on the server — desktop assumption).
 */
export const useIsBelowMd = (): boolean => {
    const [belowMd, setBelowMd] = useState(false);
    useEffect(() => {
        const query = window.matchMedia('(max-width: 767.98px)');
        setBelowMd(query.matches);
        const onChange = () => setBelowMd(query.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);
    return belowMd;
};
